const addData = (data)=>{
    $.each(data, (key, value)=>{
        if("raid-layer"!==key) {
            $(`#${key}`).css({backgroundImage:`url("${value}")`});
        }else{
            $(`#${key}`).attr("src", `${value}`);
        }
    });
};
addData(jsonData);


// WEBPACK FOOTER //
// ./src/js/fragments.js